<script setup>
    import Modal from "../../../../../components/ui-components/modal/Modal.vue";
    import { ref, watch, onMounted,  computed, defineExpose, getCurrentInstance } from "vue";
    import { usePageLoadingStore} from "../../../../../stores/pageLoading";
    import _ from 'lodash'
    import KSATextButton from "../../../../../components/ui-components/button/KSATextButton.vue";
    import certificateTemplateService from "../../../services/lecture/certificateTemplateService";
    import KSACertificateTemplatePreview from "../../../../../components/ui-components/KSACertificateTemplatePreview.vue";

    const loadingStore = usePageLoadingStore();
    const { $gbNameKR, $pageListBoardNo } = getCurrentInstance().appContext.config.globalProperties;

    const baseModal = ref(null);
    const resolvePromise = ref(null);

    const list = ref([])

    onMounted(()=>{
        setTimeout(()=>{
            baseModal.value.isAdminWrap = true;
        }, 500);
        // retrieveList();
    })

    const searchInput = ref({
        title: ''
    })

    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalPages = ref(0);
    const totalCount = ref(0);

    const pageSizeGroup = ref([
        { label:"10개씩 보기", value: "10" },
        { label:"30개씩 보기", value: "30" },
        { label:"50개씩 보기", value: "50" },
        { label:"100개씩 보기", value: "100" },
    ])

    const retrieveList = () => {
        const paramObj = {
            pageNo: currentPage.value,
            size: pageSize.value,
        };

        loadingStore.loading = true;
        certificateTemplateService.retrieveAllPaging(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                }
            }).catch( (error) =>  {
                // console.log(error);
                loadingStore.loading = false;
            });
    }

    const clearSearchInput = () => {
        searchInput.value = {
            title: ''
        }
    }

    const onClickSearch = () => {
        currentPage.value = 1;
        retrieveList();
    }

    const onSelectPage = (pageNo) => {
        currentPage.value = pageNo;
        retrieveList();
    }

    const onSelectPageSize = (option) => {
        pageSize.value = option.value;
        currentPage.value = 1;
        retrieveList();
    }

    const show = () => {
        baseModal.value.open();
        retrieveList();
        return new Promise((resolve, _) => {
            resolvePromise.value = resolve;
        });
    };

    const confirm = (template) => {
        baseModal.value.close();
        resolvePromise.value(template);
    };

    const cancel = () => {
        baseModal.value.close();
        resolvePromise.value();
    };

    const init = () => {
        clearSearchInput();
    }

    defineExpose({
        show,
        init,
    })

</script>

<template>
    <Modal ref="baseModal">
        <div class="modal-inner xl-size">
            <button class="close" @click="cancel"></button>
            <div class="modal-title">
                <h3>수료증 양식 검색</h3>
            </div>
            <div class="modal-body">
                <!-- <div class="filter-wrap open">
                    <p>검색</p>
                    <div class="filter">
                        <dl>
                            <dt>수료증명</dt>
                            <dd class="text-box">
                                <div class="grid">
                                    <KSAInput style="max-width: calc(100% - 80px;); width: 100%;" class="text-box" v-model="searchInput.title" />
                                    <KSAPrimaryButton class="ml-xs" text="검색" @click="onClickSearch" />
                                </div>
                            </dd>
                        </dl>
                    </div>
                </div> -->
                <div class="list-top">
                    <p>총 <span>{{ totalCount }}</span>개</p>
                    <div>
                        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                    </div>
                </div>
                <div class="table-form">
                    <table class="horizontal">
                        <tr>
                            <th width="5%">NO</th>
                            <th width="15%">수료증 이미지</th>
                            <th>수료증명</th>
                            <th width="15%">연결된 강의 수</th>
                            <th width="15%">등록일</th>
                            <th width="5%">선택</th>
                        </tr>
                        <tr v-for="template in list">
                            <td>{{ template.boardNo }}</td>
                            <td>
                                <KSACertificateTemplatePreview
                                    :headSrc="template.frontImageDir"
                                    :tailSrc="template.backImageDir"
                                    :frontFixedText="template.frontFixedText"
                                />
                            </td>
                            <td class="text-left">{{ template.certificateName }}</td>
                            <td class="">{{ template.linkedLectureCount }}</td>
                            <td class="">{{ $yyyymmddHHmmss(template.createDate) }}</td>
                            <td><KSATextButton text="선택" @click="confirm(template)" /></td>
                        </tr>
                        <tr v-if="list.length === 0">
                            <td colspan="6" class="text-center">
                               검색 결과가 없습니다.
                            </td>
                        </tr>
                    </table>
                </div>
                <Paginate
                    v-if="list.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
            </div>
        </div>
    </Modal>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

</style>